import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 5h14v2H5V5zm16 4h-1v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9H3V5a2 2 0 012-2h14a2 2 0 012 2v4zM6 9h12v10H6V9zm4.356 5.02l.026.021.818.768V11.5c0-.396.334-.7.725-.7.391 0 .725.304.725.7v3.413l.924-.862a.752.752 0 01.893-.01l.009.008.057.048a.671.671 0 01.049.936l-2.102 1.973a.743.743 0 01-.532.193l-.023.001a.667.667 0 01-.4-.148c-.079-.059-.148-.13-.194-.177l-.023-.024-1.925-1.81a.677.677 0 01-.266-.698.71.71 0 01.556-.528.747.747 0 01.683.206z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
